document.addEventListener("turbolinks:load", function() {
  $('#search_group').keyup(function() {
    var value = this.value.toLowerCase();
    $("#group_select > div.content > div.ui.vertical.fluid.menu > .group").each(function(index) {
      var id = $(this).text().toLowerCase();
      $(this).toggle(id.indexOf(value) !== -1);
    });
  });

});